import { styled } from "@mui/material";
import { FiMoreHorizontal as MoreIcon } from "react-icons/fi";
import { useState, useEffect } from "react";
import SettingsModal from "../Modal/settingsCustomModal";
import UpdateRoutePayment from "./DeactivateApplicant";
// import DeleteRoutePayment from "./deleteRoutePayment";
import css3 from "../../Approvals/css/approval-table.module.css";
import {
  MdOutlineArrowBackIosNew as LBtn,
  MdOutlineArrowForwardIos as RBtn,
} from "react-icons/md";

interface DeactivateApplicant {
  ApplicantId: number;
  FirstName: string;
  LastName: string;
  ActionId: number;
  ApplicationDate: string;
  Gender: string;
  MaritalStatus: string;
  Email: string;
}

interface DynamicTableProps {
  data: DeactivateApplicant[] | undefined;
}

export default function DynamicTable({ data }: DynamicTableProps) {
  const [deleteRoutePayment, setDeleteRoutePayment] = useState(false);
  const [routePaymentModal, setRoutePaymentModal] = useState(false);
  const [selectedApplicant, setSelectedApplicant] = useState<DeactivateApplicant | null>(null);
  const [activeData, setActiveData] = useState<DeactivateApplicant[]>([]);
  const [pageData, setPageData] = useState<DeactivateApplicant[]>([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageArr, setPageArr] = useState<number[]>([]);
  const [showMore, setShowMore] = useState(false);
  const [showIndex, setShowIndex] = useState<number | null>(null);

  const DATA_PER_PAGE = 10;

  const handlePrevious = () => {
    setCurrentPage((prev) => (prev === 0 ? pageArr.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => (prev === pageArr.length - 1 ? 0 : prev + 1));
  };

  const handleRoutePaymentModal = (applicant: DeactivateApplicant) => {
    setSelectedApplicant(applicant);
    setRoutePaymentModal(true);
  };

  const handleDeleteRoutePayment = (applicant: DeactivateApplicant) => {
    setSelectedApplicant(applicant);
    setDeleteRoutePayment(true);
  };

  const handleMore = (index: number) => {
    if (index === showIndex) {
      setShowIndex(null);
      setShowMore(false);
    } else {
      setShowIndex(index);
      setShowMore(true);
    }
  };

  const handleCloseRoutePaymentModal = () => {
    setRoutePaymentModal(false);
    setSelectedApplicant(null);
  };

  const handleCloseDeleteRoutePaymentModal = () => {
    setDeleteRoutePayment(false);
    setSelectedApplicant(null);
  };

  useEffect(() => {
    if (data && data.length > 0) {
      setActiveData(data);
      const pages = Math.ceil(data.length / DATA_PER_PAGE);
      const pageNumbers = Array.from({ length: pages }, (_, i) => i);
      setPageArr(pageNumbers);
      setCurrentPage(0);
    }
  }, [data]);

  useEffect(() => {
    const start = currentPage * DATA_PER_PAGE;
    const end = start + DATA_PER_PAGE;
    setPageData(activeData.slice(start, end));
  }, [activeData, currentPage]);

  return (
    <Wrapper>
      <div className={css3.container}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 0.7fr) 1fr",
            padding: "10px 0",
            borderBottom: "2px solid #ddd",
            fontWeight: "bold",
          }}
        >
          <div>First Name</div>
          <div>Last Name</div>
          <div>Date Applied</div>
          <div>Gender</div>
          <div>Marital</div>
          <div>Email</div>
        </div>

        <div>
          {pageData.map((eData, index) => (
            <div
              key={eData.ApplicantId}
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 0.7fr) 1fr",
                padding: "10px 0",
                borderBottom: "1px solid #f4f4f4",
              }}
            >
              <div>{eData.FirstName}</div>
              <div>{eData.LastName}</div>
              <div>
                {eData.ApplicationDate
                  ? new Intl.DateTimeFormat("en-GB", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }).format(new Date(eData.ApplicationDate))
                  : "N/A"}
              </div>
              <div>{eData.Gender || "N/A"}</div>
              <div>{eData.MaritalStatus || "N/A"}</div>
              <div>
                <div>{eData.Email}</div>
                <span
                  className={`${css3.moreSpan} ${
                    index === showIndex ? css3.activeMore : ""
                  }`}
                  onClick={() => handleMore(index)}
                >
                  <MoreIcon />
                  {index === showIndex && showMore && (
                    <div>
                      <div onClick={() => handleRoutePaymentModal(eData)}>
                        Delete-Applicant
                      </div>
                      {/* <div onClick={() => handleDeleteRoutePayment(eData)}>Delete</div> */}
                    </div>
                  )}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className={css3.pagination}>
          <div>
            <button onClick={handlePrevious} className={`${css3.lBtn} ${css3.btn}`}>
              <LBtn />
            </button>
            {pageArr.map((ePage, index) => {
              const isCurrent = currentPage === ePage;
              const dotSpan = (
                <span
                  key={`dot-${ePage}`}
                  style={{ padding: "0 5px", userSelect: "none" }}
                >
                  ...
                </span>
              );

              const pageButton = (
                <span
                  key={ePage}
                  style={
                    isCurrent
                      ? {
                          backgroundColor: "var(--activeP-back)",
                          color: "var(--white-color)",
                        }
                      : {}
                  }
                  onClick={() => setCurrentPage(ePage)}
                >
                  {ePage + 1}
                </span>
              );

              if (index <= 2 && currentPage <= 2) return pageButton;
              if (index === currentPage) return pageButton;
              if (index >= pageArr.length - 3 && currentPage >= pageArr.length - 3)
                return pageButton;
              if (index === 0) return [pageButton, dotSpan];
              if (index === pageArr.length - 1) return [dotSpan, pageButton];

              return null;
            })}
            <button onClick={handleNext} className={`${css3.rBtn} ${css3.btn}`}>
              <RBtn />
            </button>
          </div>
        </div>
      </div>

      <SettingsModal
        open={routePaymentModal}
        cancel={handleCloseRoutePaymentModal}
        maxWidth="800px"
        header="Delete Applicant"
        showrightIcon={false}
        content={
          selectedApplicant && (
            <UpdateRoutePayment
              DeactivateApplicantDetails={selectedApplicant}
              handleClose={handleCloseRoutePaymentModal}
            />
          )
        }
      />

      <SettingsModal
        open={deleteRoutePayment}
        cancel={handleCloseDeleteRoutePaymentModal}
        maxWidth="480px"
        header="Delete Route Payment"
        showrightIcon={false}
        // content={
        //   selectedApplicant && (
        //     <DeleteRoutePayment
        //       RoutePaymentDetails={selectedApplicant}
        //       handleClose={handleCloseDeleteRoutePaymentModal}
        //     />
        //   )
        // }
      />
    </Wrapper>
  );
}

const Wrapper = styled("div")`
  margin-inline: 48px;
`;
